document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('details').forEach((detail) => {
    detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      document.querySelectorAll('details[open]').forEach((other) => {
        if (other !== detail) other.open = false;
      });
    });
  });

  document.querySelectorAll('.buy-form select[name="id"]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const product = select.closest('.product-copy');
      const price = product?.querySelector('.price-row strong');
      const sku = product?.querySelector('[data-product-sku]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (sku && option.dataset.sku) sku.textContent = option.dataset.sku;
    });
  });
});

// Shopify's theme editor intercepts normal iframe navigation. Product links
// open in a new tab there, while the published storefront uses normal navigation.
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-product-link]');
  if (!link) return;
  const url = link.href;
  if (!url) return;
  if (window.Shopify && Shopify.designMode) {
    event.preventDefault();
    event.stopImmediatePropagation();
    window.open(url, '_blank', 'noopener');
  }
}, true);
